/*
 * @Author: WangZhengJie wangzj@geovis.com.cn
 * @Date: 2022-11-02 13:33:56
 * @LastEditors: yangguodong yanggd@geovis.com.cn
 * @LastEditTime: 2025-09-28 10:26:18
 * @FilePath: \ngtc-traceability-admin\src\app\app.module.ts
 * @Description:
 *
 * Copyright (c) 2022 by WangZhengJie wangzj@geovis.com.cn, Geovis All Rights Reserved.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_DATE_LOCALE, NZ_I18N } from 'ng-zorro-antd/i18n';
import { zh_CN } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { zhCN } from 'date-fns/locale';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { SecurityGuard } from './security/security.guard';
import { LayoutBasicModule } from './layout/layout-basic/app-frame-layout.module';
import { SecurityService } from './security/security.service';
import { ApiInterceptor } from './interceptor/api.interceptor';
import { JwtInterceptor } from './interceptor/jwt.interceptor';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { MessageService } from './common/services/message';
import { UtilsService } from './common/services/utils';
import { http } from './utils/http';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTagModule } from 'ng-zorro-antd/tag'; 
import { NzUploadModule } from 'ng-zorro-antd/upload';
//routers
// import { UserRoutingModule } from './pages/user/user-routing.module';
registerLocaleData(zh);
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzMessageModule,
    NzNotificationModule,
    NzDividerModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzTagModule,
    NzUploadModule,
    LayoutBasicModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: zh_CN }, SecurityGuard, SecurityService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    MessageService,
    UtilsService,
    http,
    // 在应用根模块中设置NZ_DATE_LOCALE的值，将激活date-fns方式的日期格式化展示
    { provide: NZ_DATE_LOCALE, useValue: zhCN }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
